import { HttpProvider } from "../http/http.provider";
import { addProvider, IProviderDescriptor, ServiceEndpointConstants } from "../ServiceUtil";
import { Observable } from "rxjs";
import { share } from "rxjs/operators";
import { IHttpRequestConfig } from "../http";

/**
 * 
 */

export class DownloadDelegate
{
    constructor(private http: HttpProvider)
    {
    }

    public getDownloadFile(filePath: string): Observable<any>
    {
        const config: IHttpRequestConfig = {
            params: {
                filePath: filePath
            },
            withCredentials: true,
            responseType: 'blob'
        };
        return this.http.get(ServiceEndpointConstants.endpoints.DOWNLOAD.DOWNLOAD_FILE, null, config).pipe(share());
    }

    public getViewFileUrl(filePath: string): Observable<any>
    {
        const config: IHttpRequestConfig = {
            params: {
                filePath: filePath
            }, responseType: 'text'
        };
        return this.http.get(ServiceEndpointConstants.endpoints.DOWNLOAD.VIEW_FILE, null, config).pipe(share());
    }

    public getQBAccessUrl(): Observable<any>
    {
        return this.http.get(ServiceEndpointConstants.endpoints.QB.ACCESS).pipe(share());
    }
}